import { $apiAllo } from '@/services/api-allo/client';

interface UseCompaniesQueryOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch companies with infinite scroll pagination.
 * Sorted by activity descending.
 */
export function useCompaniesQuery({ enabled = true }: UseCompaniesQueryOptions = {}) {
  return $apiAllo.useInfiniteQuery(
    'get',
    '/v2/company',
    {
      params: {
        query: {
          'page[size]': 50,
          sort: 'activity',
        },
      },
    },
    {
      initialPageParam: 0,
      getNextPageParam: (lastPage?: {
        metadata?: {
          pagination?: { current_page?: number; total_pages?: number };
        };
      }) => {
        const currentPage = lastPage?.metadata?.pagination?.current_page ?? 0;
        const totalPages = lastPage?.metadata?.pagination?.total_pages ?? 0;
        return currentPage < totalPages - 1 ? currentPage + 1 : undefined;
      },
      pageParamName: 'page[number]',
      staleTime: 1000 * 10,
      enabled,
    },
  );
}
